<template>
  <div class="flex justify-center items-center pointer">
    <input type="checkbox" :id="id" class="toggle hidden" />
    <label :for="id" class="switch"></label>
  </div>
</template>

<script>
export default {
  name: "BdgToggle",
  props: {
    id: { type: String, required: true }
  }
};
</script>

<style lang="scss" scoped></style>
